function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCurrentBreakpoint } from '@travel-frontend/core';
import { IconPhone } from '@travel-frontend/icons';
import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import image from '../../assets/images/calling.svg';
import { useExitIntent } from '../../components/ExitLayer/hooks/useExitIntent.js';
import { useHotlineInformation } from '../../components/hooks/useHotlineInformation.js';
import { NextImage } from '../../components/internal/NextImage/index.js';
import { Button, ContentLayer, ContentLayerBody, Flex, HeadlineLarge, HeadlineSmall, LabelLargeBold, LabelXSmall, ParagraphMedium, Stack } from '../../primitives/index.js';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "d10zl2",
  styles: "&&{width:343px;text-align:center;}"
} : {
  name: "1i9s8ws-css",
  styles: "&&{width:343px;text-align:center;};label:css;/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const ExitLayer = ({
  config,
  onClose = noop,
  onCTAClick = noop,
  onLoad = noop,
  delay = 0
}) => {
  const [open, setOpen] = useState(false);
  const currentBreakpoint = useCurrentBreakpoint();
  const {
    phoneNumbers,
    buttonText,
    openingHours,
    specials
  } = config;
  const phone = {
    xs: phoneNumbers.sm,
    ...phoneNumbers,
    xl: phoneNumbers.lg
  }[currentBreakpoint];
  const {
    short
  } = useHotlineInformation({
    openingHours,
    specials
  });
  const serviceOpeningHours = `${short.from} – ${short.to}`;
  useExitIntent({
    enabled: true,
    delay,
    optOutCookieName: 'exit-layer-opt-out',
    optOutCookieExpiryDays: 1,
    onExitIntent: () => {
      setOpen(true);
      onLoad();
    }
  });
  const handleClose = () => {
    setOpen(false);
    onClose();
  };
  const handleCTAClick = () => {
    setOpen(false);
    onCTAClick();
  };
  const {
    t
  } = useTranslation('exitLayer');
  return _jsx(ContentLayer, {
    title: "",
    open: open,
    onClose: handleClose,
    visuallyHideTitle: true,
    closeButtonLabel: "",
    css: _ref,
    children: _jsx(ContentLayerBody, {
      children: _jsxs(Flex, {
        alignItems: "center",
        children: [_jsx(NextImage, {
          image: image,
          width: 200,
          height: 200,
          alt: ""
        }), _jsxs(Stack, {
          spacing: "medium",
          alignItems: "center",
          children: [_jsx(HeadlineLarge, {
            children: t('exitLayer:title')
          }), _jsx(ParagraphMedium, {
            color: "contentSecondary",
            children: t('exitLayer:content')
          })]
        }), _jsxs(Stack, {
          spacing: "small",
          children: [_jsx(HeadlineSmall, {
            children: t('exitLayer:hotline.title')
          }), _jsxs(Stack, {
            justifyContent: "center",
            spacing: "small",
            direction: "row",
            children: [_jsx(IconPhone, {}), _jsx(LabelLargeBold, {
              as: "a",
              // @ts-expect-error ...
              href: `tel:${phone}`,
              color: "borderSelection",
              textDecoration: "none",
              children: phone
            })]
          }), _jsx(LabelXSmall, {
            color: "contentSecondary",
            children: t('exitLayer:hotline.workingHours', {
              openingHours: serviceOpeningHours
            })
          })]
        }), _jsx(Button, {
          fullWidth: true,
          variant: "info",
          onClick: handleCTAClick,
          children: buttonText ?? t('exitLayer:button')
        })]
      })
    })
  });
};